import React from 'react';
import {NavLink} from "react-router-dom";
import BaseProps from "../../types/BaseProps";

type MenuItemProps = {
  path: string;
  external?: boolean;
};

/**
 * Wrapper component for a menu item.
 */
class MenuItem extends React.Component<MenuItemProps & BaseProps> {

  render() {
    if (this.props.external) {
      return <a href={this.props.path} className="MenuItem" target="_blank" rel="noopener noreferrer">
        {this.props.children}
      </a>
    }
    return (
      <NavLink to={this.props.path} className="MenuItem" activeClassName="selected">
        {this.props.children}
      </NavLink>
    );
  }

}

export default MenuItem;
